import React from "react"
import InfiniteScroll from "@kit/design/infinite-scroll"
import { ChangelogItem } from "./changelog-item"
import LoadingAnimation from "@kit/design/loading-animation"

export function Changelog() {
  const fetchChangeLog = React.useMemo(
    () => async page => {
      const request = await fetch(
        `/onboarding/changelog_items?page=${page}`
      ).then(res => res.json())
      return request
    },
    []
  )

  return (
    <div id="changelog-container" className="max-h-full overflow-y-auto">
      <div id="changelog-content">
        <InfiniteScroll
          loadFunction={fetchChangeLog}
          scrollParentSelector="#changelog-container"
          scrollContentSelector="#changelog-content"
          pageLimit={5}
          loader={
            <div className="flex items-center justify-center w-full">
              <LoadingAnimation />
            </div>
          }
          completionMessage={
            <div className="p-4 pt-5 text-center">
              You’re all caught up!{" "}
              <span role="img" aria-label="tada icon">
                🎉
              </span>
            </div>
          }
          threshold={100}
        >
          {item => (
            <ChangelogItem
              id={item.id}
              key={item.id}
              title={item.title}
              description={item.description}
              publishedAt={item.published_at}
              link={item.link}
              isUnseen={!item.seen}
            />
          )}
        </InfiniteScroll>
      </div>
    </div>
  )
}
